import type { Site } from '../Site';

export const MotorBoatAndYachting: Site = {
  id: 'mby',
  logo: 'mby.png',
  label: 'Motor Boat & Yachting',
  analyticsName: 'mby',
  hostname: 'mby.com',
  platform: 'ti',
  selector: '#content a',
};
